import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import DashboardBannerBlock from '../DashboardBannerBlock';
import DashboardBannerListBlock from '../DashboardBannerListBlock';
import DashboardBookListBlock from '../DashboardBookListBlock';
import DashboardRecoBlock from '../DashboardRecoBlock';
import DashboardBooksetBookListBlock from '../DashboardBooksetBookListBlock';
import DashboardBooksetListBlock from '../DashboardBooksetListBlock';
import DashboardBooksetBlock from '../DashboardBooksetBlock';
import DashboardVideoBlock from '../DashboardVideoBlock';
import styles from './style.scss';


const SUPPORTED_BLOCKS = [
  'banner',
  'banner_list',
  'bookset_list',
  'reco',
  'bookset',
  'bookset_book_list',
  'book_list',
  'video',
];

const DashboardBlock = ({ block, user, halfWidth, itemKey, title }) => {
  const supportedBlocks = {
    banner: () => <DashboardBannerBlock block={block} />,
    banner_list: () => <DashboardBannerListBlock block={block} />,
    // Слайдер с подборками
    bookset_list: () => <DashboardBooksetListBlock block={block} />,
    // Слайдер с рекоммендациями
    reco: () => <DashboardRecoBlock block={block} user={user} title={title} />,
    // Баннер со ссылкой на подборку без слайдера
    bookset: () => <DashboardBooksetBlock block={block} halfWidth={halfWidth} />,
    // Слайдер с книгами и фоновым (подборка)
    bookset_book_list: () => <DashboardBooksetBookListBlock block={block} itemKey={itemKey} />,
    // Слайдер с книгами без фонового, где книги собираются в админке дашборда
    book_list: () => <DashboardBookListBlock user={user} block={block} itemKey={itemKey} />,
    // Блок с видео
    video: () => <DashboardVideoBlock block={block} itemKey={itemKey} />,
  };

  const Block = supportedBlocks[block.type];

  // ignore unsupported blocks
  if (!Block) {
    return null;
  }

  // ignore invalid resource uris
  if (!block.resource_uri || !block.resource_uri.startsWith('/api/')) {
    Raven.captureMessage('invalid dashboard block resource uri', {
      level: 'critical',
      extra: {
        block: block,
        uri: block.resource_uri,
      },
    });
    return null;
  }

  return (
    <Block />
  );
};

class DashboardSectionByDate extends React.Component {
  componentDidMount() {
    this.currentBlocksLength = get(this, 'props.blocks.length', 0);
  }

  shouldComponentUpdate(nextProps) {
    if (get(nextProps, 'user.id', null) !== get(this, 'props.user.id', null)) {
      return true;
    }
    const newBlocksLength = get(this, 'props.blocks.length', 0);
    if (newBlocksLength === this.currentBlocksLength) {
      return false;
    }
    else {
      this.currentBlocksLength = newBlocksLength;
      return true;
    }
  }

  /*
    Проверяем, растягивать ли блок c подборкой без книг на всю ширину или только на 50%

    blocks - массив блоков одного временного периода (день, неделя, месяц)
    blockIndex - индекс каждого передаваемого блока в массиве blocks
    booksetsInARowCounter - счетчик, количества блоков-подборок идущих подряд.
    Обнуляется, когда тип блока!=bookset, начинается с нуля.

    Для каждого блока проверяем:
      1. Является ли ее порядковый номер четным в ряду нескольких подряд подборок
      2. Является ли следующий блок также подборкой

    При соблюдении обоих условий, отображаем подборку на половину лейаута.
    Также если booksetsInARowCounter нечетный, то очевидно, что у нас две подряд подборки - отображаем по 50%.
  */
  checkBooksetViewCondition(blocks, blockIndex, booksetsInARowCounter) {
    return (booksetsInARowCounter % 2 !== 0 && get(blocks[blockIndex + 1], `type`, '') === 'bookset')
      || booksetsInARowCounter % 2 === 0;
  }

  renderBlocks(blocksList) {
    let blocksToRender = [];
    let booksetsInARowCounter = 0;

    for (let idx in blocksList) {
      let block = blocksList[idx];

      if (SUPPORTED_BLOCKS.indexOf(block.type) === -1) {
        continue;
      }

      block.type === 'bookset' ? booksetsInARowCounter++ : booksetsInARowCounter = 0;

      if (!(block.type === 'reco' && !this.props.user)) {
        blocksToRender.push(
          <DashboardBlock
            key={`${block.id}-${idx}-${booksetsInARowCounter}`}
            itemKey={block.id}
            block={block}
            user={this.props.user}
            title={block.title}
            halfWidth={this.checkBooksetViewCondition(blocksList, +idx, booksetsInARowCounter)} />
        );
      }
    }

    return blocksToRender;
  }

  render() {
    const { blocks, title, subtitle } = this.props;
    const blockInSection = this.renderBlocks(blocks);

    if (!blockInSection.length) {
      return null;
    }

    return (
      <React.Fragment>
        <div className={styles.dateBlocksTitle}>
          {title.length > 0 && (
            <div className={styles.dateBlocksTitleMain}>
              {title}
            </div>
          )}
          {subtitle.length > 0 && (
            <div className={styles.dateBlocksTitleSub}>
              {subtitle}
            </div>
          )}
        </div>
        <div className={styles.dateBlocksWrapper}>
          {blockInSection}
        </div>
      </React.Fragment>
    );
  }
}

DashboardSectionByDate.propTypes = {
  blocks: PropTypes.array,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

DashboardSectionByDate.defaultProps = {
  blocks: [],
  title: '',
  subtitle: '',
};

export default DashboardSectionByDate;
